import { render, staticRenderFns } from "./KitOpmeCard.vue?vue&type=template&id=725c4b1a&scoped=true"
import script from "./KitOpmeCard.vue?vue&type=script&lang=ts"
export * from "./KitOpmeCard.vue?vue&type=script&lang=ts"
import style0 from "./KitOpmeCard.vue?vue&type=style&index=0&id=725c4b1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725c4b1a",
  null
  
)

export default component.exports